<template>
  <div>
    <v-form ref="form" v-model="valid" lazy-validation>
      <div style="
          width: 100%;
          display: grid;
          grid-template-columns: 1fr 1fr 200px;
          column-gap: 10px;
          align-items: center;
          margin-bottom: 5px;
        ">
        <div class="opcionsCombox">
          <v-combobox v-model="editedItem.anoacademico" :rules="ruleRequired" item-value="pkAnoacademico"
            item-text="descricao" required :disabled="disabled" :hint="detalhe" persistent-hint :items="classes"
            label="Selecione a nova Classe" @change="loadTurmaClasse" rounded></v-combobox>
        </div>
        <div class="opcionsCombox">
          <v-combobox v-model="editedItem.turmaSelected" :rules="ruleRequired" item-text="descricao"
            :disabled="disabled" required :hint="detalhe" persistent-hint :items="turmasFiltered"
            label="Selecione a nova Turma" return-object @change="ObterNumeroEstudantesTurma()" rounded></v-combobox>
        </div>
        <v-btn color="#ee44aa" style="color: white" @click="ConfirmarMatricula()"
          :disabled="!valid || vagasDisponiveis <= 0">Confirmar</v-btn>
      </div>
    </v-form>
    <div style="margin-bottom: 5px">
      <v-col md="12" v-if="editedItem.turmaSelected !== null">
        <v-row>
          <v-card max-width="300px" class="margin-card">
            <v-card-text>
              <v-row>
                <v-col md="12">
                  <span class="boldText">Capacidade da Turma: </span>
                  <span>{{
                    editedItem.turmaSelected !== null
                      ? editedItem.turmaSelected.capacidade
                      : ""
                  }}</span>
                </v-col>
                <v-col md="12">
                  <span class="boldText">Nº Estudantes na Turma: </span>
                  <span>{{
                    numeroEstudantesCadastrado.length
                      ? numeroEstudantesCadastrado[0].qtdEstudante
                      : 0
                  }}</span>
                </v-col>
                <v-col md="12">
                  <span class="boldText">Vagas disponíveis: </span>
                  <span :style="vagasDisponiveis > 0
                      ? 'color:green;font-weight:bold;'
                      : 'color:red;font-weight:bold;'
                    ">{{ vagasDisponiveis }}</span>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-row>
      </v-col>
    </div>
    <div>
      <v-card max-width="1000" style="margin: auto">
        <v-list-item>
          <v-list-item-avatar color="grey"></v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title style="font-size: 18px">Resultado da Pesquisa</v-list-item-title>
            <v-list-item-subtitle>Dados Académico do estudante</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-row>
          <v-col md="12">
            <v-data-table :headers="headers" :items="historicoAcademico"></v-data-table>
          </v-col>
        </v-row>
      </v-card>
    </div>
  </div>
</template>
<script>
import axios from "../../plugins/axios";
import utilitarios from "../../plugins/utilitarios";
import Swal from "sweetalert2";
const ls = require("local-storage");

export default {
  name: "confirmarEstudante",
  props: ["estudante"],
  data: () => ({
    items: ["Foo", "Bar", "Fizz", "Buzz"],
    estudantes: [],
    turmasAll: [],
    numeroEstudantesCadastrado: [],
    listaDeClassesPorLancarNotas: [],
    semestres: [
      { id: 1, descricao: "Iº Semestre" },
      { id: 2, descricao: "IIº Semestre" },
    ],
    turmasFiltered: [],
    pesquisa_parameto: [],
    historicoAcademico: [],
    valid: true,
    jaMatriculado: "",
    classe: "",
    detalhe: "",
    disabled: false,
    progresso: false,
    isLoading: false,
    isLoading_: false,
    search: null,
    exibe: false,
    acesso: [],
    turmasAll: [],
    estudanteSelected: null,
    classes: [],
    classesFiltered: [],
    anosacademicos: [],
    overlay: false,
    descriptionLimit: 60,
    entries: [],
    classes: [],
    search2: null,
    turma: null,
    filter: false,
    editedItem: {
      objecto: null,
      Turma: null,
      semestre: null,
      anoacademico: null,
      classe: null,
      estudante: null,
      turmaSelected: null,
      autor: ls.get("nomeUsuario"),
    },
    defaultItem: {
      objecto: null,
      Turma: null,
      classe: null,
      anoacademico: null,
      semestre: null,
      estudante: null,
      turmaSelected: null,
      autor: ls.get("nomeUsuario"),
    },
    headers: [
      { text: "Curso", value: "curso" },
      { text: "Ultima Classe Feita", value: "classe" },
      { text: "Ultima turma", value: "turma" },
      { text: "Anolectivo", value: "anoLectivo" },
      { text: "Resultado", value: "resultado" },
    ],
    ruleRequired: [(value) => value || "campo obrigatorio"],
  }),

  computed: {
    vagasDisponiveis() {
      return (
        parseInt(
          this.editedItem.turmaSelected === null
            ? 0
            : this.editedItem.turmaSelected.capacidade
        ) -
        parseInt(
          this.numeroEstudantesCadastrado.length
            ? this.numeroEstudantesCadastrado[0].qtdEstudante
            : 0
        )
      );
    },

    ListaActividades() {
      return ls.get("lista_actividades");
    },
    anolectivoActual() {
      return ls.get("anolectivo");
    },
    fields() {
      if (!this.model) return [];

      return Object.keys(this.model).map((key) => {
        return {
          key,
          value: this.model[key] || "n/a",
        };
      });
    },
  },

  created() {
    this.editedItem.estudante = this.estudante;
    this.editedItem.estudante.idMatricula = this.estudante.numero_matricula;
    this.editedItem.estudante.pkPessoa = this.estudante.idCliente;
    this.SelecionaEstudante();
    this.initializeClasses();
    this.initializeturmasAll();
  },

  methods: {
    async SelecionaEstudante() {
      if (this.estudante) {
        // Se o estudante for encontrado,
        this.historicoAcademico = await this.ObterHistoricoAcademico().then(
          (res) => res.data
        );
        if (this.historicoAcademico.length) {
          if (this.historicoAcademico[0].anoLectivo === this.anolectivoActual) {
            this.valid = false;
            Swal.fire(
              "Informação",
              "Estudante já confirmado no anolectivo actual",
              "warning"
            );
            this.$emit("fecharComponente", false);
          }
        }
      } else {
        Swal.fire("Informação", "Estudante não encontrado!", "warning");
      }
    },

    async ObterHistoricoAcademico() {
      try {
        let params = { idMatricula: this.estudante.numero_matricula };
        return await axios.post("/ObterInscricaoTurmaEstudante", params);
      } catch (error) {
        Swal.fire(
          "Informação",
          "<p>Ocorreu um erro ao tentar efectuar a operação.</p>",
          "warning"
        );
      }
    },

    async initializeClasses() {
      try {
        this.isLoading = true;
        this.classes = await axios
          .get("/classeFindAll2")
          .then((res) => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      } finally {
        this.isLoading = false;
      }
    },

    async initializeTurmas() {
      try {
        this.isLoading = true;
        this.turmasAll = await axios
          .get("/turmasFindAlls")
          .then((res) => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      } finally {
        this.isLoading = false;
      }
    },

    async ConfirmarMatricula() {
      if (this.$refs.form.validate()) {        
        this.overlay = true;
        this.editedItem.ultimoAnoFeito = this.historicoAcademico[0].anoLectivo;
        let params = {
          dados: this.editedItem,
        };

        try {
          this.isLoading = true;
          let result = await axios
            .post("/confirmacaoInsertOrUpdate", params)
            .then((res) => res);

          if (result.status == 200 && result.data.affectedRows >= 0) {
            Swal.fire("Informação", "Confirmação feita com sucesso", "success");
            this.editedItem = this.defaultItem;
            this.$emit("fecharComponente", false);
          } else {
            Swal.fire(
              "Informação",
              "Ocorreu um erro ao tentar efectuar a operação.",
              "error"
            );
          }
        } catch (error) {
          this.text = error;
          this.$store.dispatch("textMessage", {
            msg: this.text,
            classMessage: "msgError",
            timeout: 3000,
          });
        } finally {
          this.overlay = false;
          this.isLoading = false;
        }
      }
    },

    async ObterNumeroEstudantesTurma() {
      try {
        this.numeroEstudantesCadastrado = await axios
          .post("ObterNumeroIscritoEstudantesTurma", {
            turma: this.editedItem.turmaSelected,
          })
          .then((res) => res.data);
      } catch (error) { }
    },

    async initializeturmasAll() {
      //  turmaFindWithEstudanteCount
      try {
        this.isLoading = true;
        this.turmasAll = await axios
          .get("/turmaFindAll/" + this.idclasse)
          .then((res) => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      } finally {
        this.isLoading = false;
      }
    },

    async turmaFindWithEstudanteCount() {
      try {
        this.listaDeClassesPorLancarNotas = await axios
          .get("/turmaFindWithEstudanteCount/" + "all") // idclasse JyUn JQ==
          .then((res) => res.data);
      } catch (error) {
        // this.isLoading = false

        // this.text = error
        this.$store.dispatch("textMessage", {
          msg: error,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
      this.listEstudantfromPauta = [];
    },

    async verificaSeJaConfirmado() {
      try {
        return await axios
          .post("/Estudante-ja-Confirmado", this.editedItem.objecto)
          .then((res) => res.data);
      } catch (error) {
        this.$store.dispatch("textMessage", {
          msg: error,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    },

    async initializeClasses() {
      try {
        this.isLoading = true;
        this.classes = await axios
          .get("/anoacademicoFindAll")
          .then((res) => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      } finally {
        this.isLoading = false;
      }
    },

    async CarregActividades() {
      try {
        this.$store.state.actividades = await axios
          .get("/listAberturaFechoInstituicao")
          .then((res) => res.data);
      } catch (error) { }
    },
    async loadTurmaComb() {
      // setTimeout(() => { this.editedItem.turma=undefined }, 0)
      this.classesFiltered = this.classes.filter(
        (c) => c.nivel === this.editedItem.objecto.nivel_ensino
      );
      let result = await this.verificaSeJaConfirmado().then();
      if (result.qtd <= 0) {
        this.disabled = false;
      } else {
        // Já tem a matrícula ou confirmação feita neste anolectivo
        this.$emit("fecharComponente", false);
        this.$store.dispatch("textMessage", {
          msg: "Estudante já confirmado no anolectivo actual",
          classMessage: "msgError",
          timeout: 8000,
        });
      }
    },

    loadTurmaClasse() {
      this.turmasFiltered = this.turmasAll.filter(
        (t) =>
          t.idCurso === this.editedItem.estudante.idCurso &&
          t.idAno_Academico === this.editedItem.anoacademico.idAno_Academico
      );
    },
  },
};
</script>
<style scoped>
.boldText {
  font-weight: bolder;
  font-size: 15px;
}

.opcionsCombox {
  height: 55px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0 5px;
}
</style>
